export default {"src":"/_next/static/media/sbi.20acebb7.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};